  let screen_width = window.innerWidth;
  //console.log('screen_width', screen_width);

  //Mega-menu hover functionality
  //const screen_width = $(window).width();
  // if( screen_width > 1024 ){
  //   $('.mega-menu').hover(function(){
  //       $(this).attr('open', '');
  //       $(this).find('.header__menu-item').attr('aria-expanded', 'true');
  //   },function(){
  //       $(this).removeAttr('open', '');
  //       $(this).find('.header__menu-item').attr('aria-expanded', 'false');      
  //   });
  // }

  let filterBtnCollection = document.querySelectorAll('.collection-filters-section .filter-section');
  if(filterBtnCollection){
    filterBtnCollection.forEach(function(filtEle){
      filtEle.querySelector('.filter-title').addEventListener('click', function(ele){
        filtEle.classList.toggle('active');
      });
    })
  }

  let filterBtnLocations = document.querySelector('.header-location-tab-block');
  if(filterBtnLocations){
    filterBtnLocations.querySelector('.location-head-title').addEventListener('click', function(ele){
      filterBtnLocations.classList.toggle('active');
      filterBtnLocations.querySelector('.location-tab-group').classList.toggle('show');
    });
  }


  //location tabs
  let locationsTabs = function(){
    // $(document).on('click','.location-block-section .location-header-section .header-location-tab-block .location-head-title', function(){
    //   $('.location-block-section .location-header-section .header-location-tab-block .location-tab-group').toggleClass('show');
    // });
    $(document).on('click', '.location-block-section .location-header-section .header-location-tab-block .header-location-tab h2', function(){
      $('.location-block-section .location-header-section .header-location-tab-block .header-location-tab').removeClass('active');
      $('.product-location-map-lists .locations-block-section').removeClass('active');
      var currentId = $(this).data('location-title');
      $(this).parent().addClass('active');
      var currentText = $(this).text();
      $('.location-block-section .location-header-section .header-location-tab-block .location-head-title span').text(currentText);
      $('.product-location-map-lists .locations-block-section[data-location-content="'+currentId+'"]').addClass('active');
      $('.location-block-section .location-header-section .header-location-tab-block .location-tab-group').removeClass('show');
      
      // updating URL on city change code
      let currentCity = this.innerText;
      currentCity = currentCity.trim().toLowerCase();

      // Build clean URL format: /pages/location/cityname
      let newURL = '/pages/location/' + currentCity;
      window.history.pushState("object or string", "Location", newURL);
      // updating URL on city change code ends
      
    });
  };
  locationsTabs();

  // updating URL on page load
  let currentURL = window.location.href;
  if(currentURL.includes('/pages/location')){
      // extract city from path instead of query
    let pathParts = currentURL.split('/pages/location/');
    if(pathParts.length > 1 && pathParts[1] !== ''){
      let currentCity = pathParts[1].toLowerCase();
      document.querySelectorAll('.header-location-tab').forEach(function(ele, ind){
        ele.classList.remove('active');
        let city = ele.innerText.trim().toLowerCase();
        if(city == currentCity){
          ele.classList.add('active');
          document.querySelector('.header-location-tab-block .location-head-title span').innerText = city;
          let dataLocationTitle = ele.querySelector('h2').getAttribute('data-location-title');
          document.querySelectorAll('.locations-block-section').forEach(function(ele){
            ele.classList.remove('active');
            let dataLocationContent = ele.getAttribute('data-location-content');
            if(dataLocationContent == dataLocationTitle){
              ele.classList.add('active');
            }
          });
          document.querySelector('.location-block-section').style.display = 'block';
        }
      });
    }else{
      // Default city if none is in URL
      let newURLonLoad = '/pages/location/barcelona';
      window.history.pushState("object or string", "Location", newURLonLoad);
    } 
  }
  // updating URL on page load ends

  document.addEventListener('DOMContentLoaded', function (){
  
      //custom menu drawer
      document.querySelector('#menu-drawer svg.menu-drawer-close').addEventListener('click', function(ele){        
        document.querySelector('#Details-menu-drawer-container').classList.remove('menu-opening');
        document.querySelector('#Details-menu-drawer-container').removeAttribute('open');
        document.querySelector('#Details-menu-drawer-container summary').setAttribute('aria-expanded', 'false');
        document.querySelector('body.gradient').classList.remove('overflow-hidden-tablet');
      });
    
      
      document.querySelector('[data-toggle="level-1-dropdown-header"]').addEventListener('click', function(ele){
        this.classList.toggle('active')
        document.querySelector('[data-toggle="level-1-dropdown-content"]').classList.toggle('hide');
      });

    
    
      //PRODUCT PAGE SCRIPT STARTS
           
      let productMediaWrapV2 = document.querySelector('.product-media-v2-wrap');
      if(productMediaWrapV2){
        productMediaWrapV2.querySelectorAll('.owl-nav button').forEach(function(slideBtnEle){
          slideBtnEle.addEventListener('click', function(event) {
            let sliderBtnClass = slideBtnEle.getAttribute('class');
            //console.log('sliderBtnClass', sliderBtnClass);
            //prev
            if(sliderBtnClass == 'owl-prev'){
              setTimeout(function(){
                //console.log('prev');
                let slideMedia = productMediaWrapV2.querySelector('img.slide-media');
                let SM_Classlist = slideMedia.classList;
                let activeItem = productMediaWrapV2.querySelector('.owl-item.active .item');
                
                if(activeItem.hasAttribute('data-image-background')){
                  activeItem.setAttribute('style', 'visibility: hidden; opacity: 0');
                  let activeMediaURL = activeItem.querySelector('.item img').getAttribute('src');
                  slideMedia.setAttribute('src', activeMediaURL);              
                  if(SM_Classlist.contains('slide-from-left')){
                    //console.log('prev if');
                    SM_Classlist.add('slide-to-right'); 
                    SM_Classlist.remove('slide-from-left');
                    setTimeout(function(){ 
                      SM_Classlist.remove('slide-to-right');  
                      SM_Classlist.add('slide-from-left');
                    }, 100);
                  }else{
                    //console.log('prev else');
                    SM_Classlist.add('slide-from-left');
                    SM_Classlist.remove('slide-to-right');
                    SM_Classlist.remove('slide-from-right');
                  }              
                  productMediaWrapV2.classList.add('mediaBackgroundActive'); 
                }else{              
                  //console.log('not found prev');
                  activeItem.setAttribute('style', 'visibility: visible; opacity: 1');
                  productMediaWrapV2.classList.remove('mediaBackgroundActive');
                  slideMedia.setAttribute('src', '');
                  slideMedia.classList.remove('slide-from-left');
                }
              }, 10);
            }
            //next
            if(sliderBtnClass == 'owl-next'){
              setTimeout(function(){
                //console.log('next');
                let slideMedia = productMediaWrapV2.querySelector('img.slide-media');
                let SM_Classlist = slideMedia.classList;
                let activeItem = productMediaWrapV2.querySelector('.owl-item.active .item');
                
                if(activeItem.hasAttribute('data-image-background')){
                  activeItem.setAttribute('style', 'visibility: hidden; opacity: 0');
                  let activeMediaURL = activeItem.querySelector('.item img').getAttribute('src');
                  slideMedia.setAttribute('src', activeMediaURL);              
                  if(SM_Classlist.contains('slide-from-right')){
                    //console.log('next if');
                    SM_Classlist.add('slide-to-left'); 
                    SM_Classlist.remove('slide-from-right');
                    setTimeout(function(){ 
                      SM_Classlist.remove('slide-to-left');  
                      SM_Classlist.add('slide-from-right');
                    }, 100);
                  }else{
                    //console.log('next else');
                    SM_Classlist.add('slide-from-right');
                    SM_Classlist.remove('slide-to-left');  
                    SM_Classlist.remove('slide-from-left');
                  }              
                  productMediaWrapV2.classList.add('mediaBackgroundActive'); 
                }else{              
                  //console.log('not found next');
                  activeItem.setAttribute('style', 'visibility: visible; opacity: 1');
                  productMediaWrapV2.classList.remove('mediaBackgroundActive');
                  slideMedia.setAttribute('src', '');
                  slideMedia.classList.remove('slide-from-right');
                }
              }, 10);
            }
            
          });
        });
      }
    
      //variant change by color selection
      function variantImageSlide(value){
        let productSliderV2 = $('#product-slider-v2');
        let variant_slider= document.querySelectorAll("#product-slider-v2 .item");
        variant_slider.forEach(function(slideEle) {
          let variant_title = slideEle.getAttribute('data-variant-title');
          if(variant_title == value){
            let productMediaWrapV2 = document.querySelector('.product-media-v2-wrap');
            let slideMedia = document.querySelector('img.slide-media');
            let activeItem = document.querySelector('.owl-item.active .item');
            productMediaWrapV2.classList.remove('mediaBackgroundActive');
            slideMedia.setAttribute('src', '');
            activeItem.setAttribute('style', 'visibility: visible; opacity: 1');
            let dataInd = slideEle.getAttribute('data-index');
            //console.log('dataInd', dataInd)
            productSliderV2.trigger("to.owl.carousel", [dataInd, 500, true]);
          }
        });
      }     
      let productColorVariantSelect = document.querySelector('.product-form__input.option-Color .select select');
      if(productColorVariantSelect){
        productColorVariantSelect.addEventListener('change', function(ele){          
          let dataVariantTitle = ele.target.value;
          dataVariantTitle = dataVariantTitle.trim();
          if (dataVariantTitle == 'Select One') return;
          variantImageSlide(dataVariantTitle);
        });
      }
        
      let product_ATC_btn = document.querySelector('button.product-form__submit');
      if(product_ATC_btn){
        product_ATC_btn.addEventListener('mouseenter', function(){
          if(product_ATC_btn.hasAttribute('disabled')){
            let tooltip_ATC = document.querySelector('.product-form__buttons .tooltip_ATC');        
            tooltip_ATC.classList.toggle('active');      
          }
        });
        product_ATC_btn.addEventListener('mouseleave', function(){
          if(product_ATC_btn.hasAttribute('disabled')){
            let tooltip_ATC = document.querySelector('.product-form__buttons .tooltip_ATC');        
            tooltip_ATC.classList.toggle('active');      
          }
        });
      }
    
      //on select change, toggle active on select
      let product_Select_1 = document.querySelector('variant-selects .product-form__input:nth-child(1) .select__select');
      let product_Select_2 = document.querySelector('variant-selects .product-form__input:nth-child(2) .select__select');
      let product_Select_3 = document.querySelector('variant-selects .product-form__input-metafields .select__select');
      
      if(product_Select_1){
        //if the product has variants, disable ATC Button on load
        let product_ATC_btn = document.querySelector('button.product-form__submit');
        if(product_ATC_btn){
          product_ATC_btn.setAttribute('disabled', 'disabled');
        }
        
        product_Select_1.addEventListener('change', function(ele){
          function greet() {
              let currenturl = window.location.href;
              var splitURL=currenturl.toString().split("variant=");
              //console.log(splitURL[1]);
             let selectoption = document.querySelectorAll('.select_select option');
              selectoption.forEach(function(Ele){
                let variantid = Ele.getAttribute('varid');
                //console.log(variantid);
                if(splitURL[1] == variantid){
                  let price = Ele.getAttribute('varprice');
                  let compare_price = Ele.getAttribute('var_compare_price');
                  let compare_price_string = ``;
                  if(compare_price != ''){
                    compare_price_string = ` <del>${compare_price}</del> `;
                  }
                  document.getElementById("variantpri").innerHTML = ` - ${compare_price_string} ${price}`;
                }
              })
          }
          setTimeout(greet, 500);
          let selected_Val = ele.target.value;
          //console.log('selected_Val', selected_Val)
          if(selected_Val == 'Select One'){
            ele.target.classList.remove('active');              
          }else{
            ele.target.classList.add('active');
          }
        });
      }
      if(product_Select_2){
        product_Select_2.addEventListener('change', function(ele){
          function greet() {
              let currenturl = window.location.href;
              var splitURL=currenturl.toString().split("variant=");
              //console.log(splitURL[1]);
             let selectoption = document.querySelectorAll('.select_select option');
              selectoption.forEach(function(Ele){
                let variantid = Ele.getAttribute('varid');
                //console.log(variantid);
                if(splitURL[1] == variantid){
                  let price = Ele.getAttribute('varprice');
                  let compare_price = Ele.getAttribute('var_compare_price');
                  let compare_price_string = ``;
                  if(compare_price != ''){
                    compare_price_string = ` <del>${compare_price}</del> `;
                  }
                  document.getElementById("variantpri").innerHTML = ` - ${compare_price_string} ${price}`;
                }
              })
          }
          setTimeout(greet, 500);
          let selected_Val = ele.target.value;
          //console.log('selected_Val', selected_Val)
          if(selected_Val == 'Select One'){
            ele.target.classList.remove('active');              
          }else{
            ele.target.classList.add('active');
          }
        });
      }
      if(product_Select_3){
        product_Select_3.addEventListener('change', function(ele){
          let selected_Val = ele.target.value;
          //console.log('selected_Val', selected_Val)
          if(selected_Val == 'Select One'){
            ele.target.classList.remove('active');              
          }else{
            ele.target.classList.add('active');
          }
          document.querySelector('#groundProperties').value = selected_Val;
        });
      }    
      //variant change and ATC button update ends
    
      //description read more/less toggle
      let descriptionWrap = document.querySelector('.product-description-wrap-v2');
      let descriptionSubscriptionWrap = document.querySelector('.product-description-wrap-v2.subscription-product');
    
      let descriptionWithMetafields = document.querySelector('.product-description-wrap-v2.desc-with-metafields .description-data .content');
      let descriptionWithoutMetafields = document.querySelector('.product-description-wrap-v2.desc-without-metafields .description-data .content');
    
      let descriptionSubscription = document.querySelector('.product-description-wrap-v2.subscription-product .description-data .content');
    
      if(descriptionWrap){
        let descripToggleRead = descriptionWrap.querySelector('#toggleRead');
          if(descripToggleRead){
            descripToggleRead.addEventListener('click', function(ele){
            let targetText = ele.target.getAttribute('data-content');
            if(targetText.includes('read-more')){
              if(descriptionWithMetafields){              
                descriptionWithMetafields.setAttribute('style', 'max-height: unset;overflow: unset;');
              }
              if(descriptionWithoutMetafields){              
                descriptionWithoutMetafields.setAttribute('style', 'max-height: unset;overflow: unset;');
              }
              if(descriptionSubscription){              
                descriptionSubscription.setAttribute('style', 'max-height: unset;overflow: unset;');
              }
              ele.target.setAttribute('data-content', 'read-less');
              ele.target.textContent = 'Read less...';
              if(screen_width > 768){//desktop
                if(descriptionSubscriptionWrap){                    
                  descriptionSubscriptionWrap.setAttribute('style', 'max-height: 220px;overflow: auto;padding-right: 3px;');
                }else{
                  descriptionWrap.setAttribute('style', 'max-height: 370px;overflow: auto;padding-right: 3px;');                  
                }
              }else{//mobile
                //if(descriptionSubscriptionWrap){                    
                  //descriptionSubscriptionWrap.setAttribute('style', 'max-height: 220px;overflow: auto;padding-right: 3px;');
                //}else{
                  descriptionWrap.setAttribute('style', 'max-height: 440px;overflow: auto;padding-right: 3px;');
                //}
              }
              
            }
            if(targetText.includes('read-less')){
              if(screen_width > 768){//desktop
                if(descriptionWithMetafields){              
                  descriptionWithMetafields.setAttribute('style', 'max-height: 95px;overflow: hidden;');
                }
                if(descriptionWithoutMetafields){              
                  descriptionWithoutMetafields.setAttribute('style', 'max-height: 310px;overflow: hidden;');
                }
                if(descriptionSubscription){              
                  descriptionSubscription.setAttribute('style', 'max-height: 170px;overflow: hidden;');
                }
              }else{//mobile
                if(descriptionWithMetafields){              
                  descriptionWithMetafields.setAttribute('style', 'max-height: 95px;overflow: hidden;');
                }
                if(descriptionWithoutMetafields){              
                  descriptionWithoutMetafields.setAttribute('style', 'max-height: 360px;overflow: hidden;');
                }
                // if(descriptionSubscription){              
                //   descriptionSubscription.setAttribute('style', 'max-height: 170px;overflow: hidden;');
                // }
              }
              ele.target.setAttribute('data-content', 'read-more');
              ele.target.textContent = 'Read more...';
              descriptionWrap.setAttribute('style', 'max-height: unset;overflow: unset ;padding-right: unset;');
            }    
          });
        }
      }
      //description read more/less toggle ends
    
      //PRODUCT PAGE SCRIPT ENDS

    
      //Blog filter Toggle
      let filterBtnBlog = document.querySelector('.filter-section');
      if(filterBtnBlog){
        let filterHeading = filterBtnBlog.querySelector('.heading');
        if(filterHeading){
          filterHeading.addEventListener('click', function(ele){
            filterBtnBlog.classList.toggle('active');
            filterBtnBlog.querySelector('.content').classList.toggle('show');
          });
        }
      }
    
    
    
  }, false);//doc ready endsss

















